import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { QuarantinedReportService } from '../../../services/quarantined-report.service';
import { ModalService } from '../../../services/modal.service';
import { QuarantineState } from '../../../models/quarantine_State';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-quarantined-report',
  templateUrl: './quarantined-report.component.html',
  styleUrls: ['./quarantined-report.component.css']
})
export class QuarantinedReportComponent implements OnInit {
  modalService: ModalService;

  filter: any = {
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    batch_Num: "",
    zone: 1,
    quick_Search: ""
  };

  selectedItems = Array<any>();
  allSelected = false;

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;
  is_client = false;
  client;

  showHistory: boolean = false;
  cylinder_Id: string;
  cylinder_Serial_No: string;

  availableOptions: string[] = [
    'Serial #',
    'Fill Date',
    'Batch #',
    'Fill Pressure',
    'User',
    '# of Cylinders',
    '# of Rejects',
    'Expiry Date',
    'Released By'
];

selectedOptions: string[] = [
  'Serial #',
  'Fill Date',
  'Batch #',
  'Fill Pressure',
  'User',
  '# of Cylinders',
  '# of Rejects',
  'Expiry Date',
  'Released By'
];


  constructor(authService: AuthService, public quarantinedReportService: QuarantinedReportService, public router: Router, modalService: ModalService, private columnService: ColumnService) {

    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
    this.modalService = modalService;

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    this.loadTable(this.page);

  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  loadFillBatchCyl(row: any) {
    this.router.navigate(['reports/fill_batch_cyl'], {
      queryParams: {
        fill_Batch_Id: row.fill_Batch_ID,
        reject: false
      }
    });
  }

  loadFillBatchCylReject(row: any) {
    this.router.navigate(['reports/fill_batch_cyl'], {
      queryParams: {
        fill_Batch_Id: row.fill_Batch_ID,
        reject: true
      }
    });
  }

  itemSelected(row: any) {

    if (this.selectedItems.find(i => i.fill_Batch_ID == row.fill_Batch_ID) == undefined) {
      this.selectedItems.push(row);
      this.rows.find(i => i.fill_Batch_ID == row.fill_Batch_ID).isSelected = true;
    }
    else {
      let index = this.selectedItems.findIndex(i => i.fill_Batch_ID == row.fill_Batch_ID);
      this.selectedItems.splice(index, 1);
      this.rows.find(i => i.fill_Batch_ID == row.fill_Batch_ID).isSelected = false;
    }

    this.checkAllSelected();
  }

  selectAll() {
    for (let i = 0; i < this.rows.length; i++) {
      let id = this.rows[i].fill_Batch_ID;
      if (this.selectedItems.find(i => i.fill_Batch_ID == id) == undefined) {
        this.selectedItems.push(this.rows[i]);
        this.rows[i].isSelected = true;
      }
    }

    this.checkAllSelected();
  }

  deselectAll() {

    for (let i = 0; i < this.rows.length; i++) {
      let id = this.rows[i].fill_Batch_ID;
      let index = this.selectedItems.findIndex(i => i.fill_Batch_ID == id);
      this.selectedItems.splice(index, 1);
      this.rows[i].isSelected = false;
    }

    this.checkAllSelected();
  }

  checkAllSelected() {
    for (let i = 0; i < this.rows.length; i++) {
      if (this.rows[i].isSelected == false) {
        this.allSelected = false;
        return;
      }
      else {
        this.allSelected = true;
      }
    }
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {

    if (!event.column.prop) {
      return false;
    }

    const sortMapping = {
      'fill_Date_Display': 'fill_Date_Sorting',
      'expiry_Date_Display': 'expiry_Date_Sorting',
    };

    const sortOrder = event.newValue;
    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = sortOrder;
    this.page.sortBy = sortBy;

    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.quarantinedReportService.getResults(this.page, this.filter.batch_Num, this.filter.start_Date, this.filter.end_Date, this.filter.zone, this.filter.quick_Search).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      for (let i = 0; i < this.rows.length; i++) {
        let id = this.rows[i].fill_Batch_ID;
        if (this.selectedItems.find(i => i.fill_Batch_ID == id) != undefined) {
          this.rows[i].isSelected = true;
        }
        else {
          this.rows[i].isSelected = false;
        }
      }
      this.checkAllSelected();

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.selectedItems = [];
    this.loadTable(this.page);
  }

  quarantineSelection() {

    let quarantineStates = Array<QuarantineState>();

    for (let i = 0; i < this.selectedItems.length; i++) {
      var state = new QuarantineState;

      state.fill_Batch_ID = this.selectedItems[i].fill_Batch_ID;
      state.quarantined = true;
      state.firstname = this.client.firstname;
      state.lastname = this.client.lastname;
      quarantineStates.push(state);
    }

    this.quarantinedReportService.updateQuarantineState(quarantineStates).then((data) => {
      this.onRefresh();
    });
  }

  releaseSelection() {

    let quarantineStates = Array<QuarantineState>();

    for (let i = 0; i < this.selectedItems.length; i++) {
      var state = new QuarantineState;

      state.fill_Batch_ID = this.selectedItems[i].fill_Batch_ID;
      state.quarantined = false;
      state.firstname = this.client.firstname;
      state.lastname = this.client.lastname;
      quarantineStates.push(state);
    }

    this.quarantinedReportService.updateQuarantineState(quarantineStates).then((data) => {
      this.onRefresh();
    });
  }

  generateExcel() {
    this.quarantinedReportService.getExcel(this.filter.batch_Num, this.filter.start_Date, this.filter.end_Date, this.filter.zone).then((data) => {
      importedSaveAs(data, 'Batches.xlsx');
    });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "quarantinedReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "quarantinedReport", this.selectedOptions).then((data) => {
    });
  }
}

